import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import colores from '../../shared/constants/styles';
import {
    getDatosCuentaBancaria,
    updateDatosCuentaBancaria,
    deleteDatosCuentaBancaria
} from "../../actions/configuracion";
import {
    Button,
    Box,
    CircularProgress,
    Alert,
    Stack,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";
import { GetCuentaBancariaColumns, ICuentaBancaria } from "./interface/iCuentaBancaria";
import CuentaBancariaDialog from './formularioCuentaBancaria';


const useStyles = makeStyles({
    table: {
        minWidth: 750,
    },
    paper: {
        width: '100%', 
        mb: 2
    }
});

const CuentaBancaria = (props: any) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [cuentaBancarias, setCuentaBancarias] = useState<ICuentaBancaria[] | null>([]);    
    const [loadingCuentaBancaria, setLoadingCuentaBancaria] = useState(false);
    const [error, setError] = useState<string>("");
    const [cuentaSeleccionado, setCuentaSeleccionado] = useState<ICuentaBancaria | undefined>(undefined);
    const [cuentaAEliminar, setCuentaAEliminar] = useState<ICuentaBancaria | null>(null);
    const [openConfirmDelete, setOpenConfirmDelete] = useState<boolean>(false);
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        dispatch(getDatosCuentaBancaria());
    }, []);

    useEffect(() => {
        if (props.datosCuentaBancaria) {
            setCuentaBancarias(props.datosCuentaBancaria.$values);
        }
        setLoadingCuentaBancaria(false);
    }, [props.datosCuentaBancaria]);

    useEffect(() => {
        setLoadingCuentaBancaria(false);
        if (props.deleteCuentaResponse && props.deleteCuentaResponse.data) {
            dispatch(getDatosCuentaBancaria());
        }
    }, [props.deleteCuentaResponse]);

    useEffect(() => {
        setLoadingCuentaBancaria(false);
        if (props.updateCuentaResponse && props.updateCuentaResponse.data) {
            dispatch(getDatosCuentaBancaria());
        }
    }, [props.updateCuentaResponse]);

    const handleGuardar = (cuentaSeleccionado: ICuentaBancaria) => {  
        setOpenDialog(false);
        setCuentaSeleccionado(undefined);
        dispatch(updateDatosCuentaBancaria(cuentaSeleccionado));
    };

    const handleCrearDatos= () => {
        setError("");
        setOpenDialog(true);
    }

    const handleEdit = (cuentaBancaria: ICuentaBancaria) => {
        setCuentaSeleccionado(cuentaBancaria);
        setOpenDialog(true);
    };
    
    const handleDelete = (cuentaBancaria: ICuentaBancaria) => {
        setCuentaAEliminar(cuentaBancaria);
        setOpenConfirmDelete(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCuentaSeleccionado(undefined);
    };
    
    const handleCancelarEliminacion = () => {
        setOpenConfirmDelete(false);
        setCuentaAEliminar(null);
    };

    const handleConfirmarEliminacion = () => {
        if (cuentaAEliminar) {
            dispatch(deleteDatosCuentaBancaria(cuentaAEliminar.id)); 
        }
        setOpenConfirmDelete(false);
    };

    return (
        <>
        <Box sx={{ m: 4 }}>
            <div className="row" style={{width: "100%", margin: '2vw'}}>
                <div className="col-2">
                    <Button
                            className="my-3"
                            style={{ backgroundColor: colores.rojo, color: '#fff', float: 'right' }}
                            variant="contained"
                            onClick={() => handleCrearDatos()}
                            type="button"
                        >
                        CREAR NUEVOS DATOS
                    </Button> 
                </div> 
            </div>
            <Stack spacing={12} maxWidth={'100%'}>
                <Box sx={{ width: '100%' }}>
                    <Paper className={classes.paper}>
                        <TableContainer>
                            {props.loading && 
                                <Box sx={{ display: 'flex',  justifyContent: 'center' }}>
                                    <CircularProgress />
                                </Box>
                            }    
                            { cuentaBancarias && cuentaBancarias.length <= 0 && 
                                <Stack sx={{ width: '100%', margin: '2vh' }} spacing={2}>
                                    <Alert severity="info">No tiene datos de la cuenta bancaria.</Alert>
                                </Stack>
                            }
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <TableHead className="backgroundColor-grey">
                                    <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.table}
                                        >
                                        {GetCuentaBancariaColumns(handleEdit, handleDelete).map((column) => (
                                            <TableCell className="fontWeight-bold" align="center">{column.dataKey == "acciones" ? '' :column.label}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    cuentaBancarias?.map((row: any)=> (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.table}
                                        >
                                            {GetCuentaBancariaColumns(handleEdit, handleDelete).map((column) => (
                                                <TableCell align="center">
                                                    {column.dataKey !== 'acciones' ? (
                                                        row[column.dataKey]
                                                    ) : (
                                                        column.cellRenderer
                                                            ? column.cellRenderer({ rowData: row }) 
                                                            : null
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                }                                            
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>

                {loadingCuentaBancaria && (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                )}

                { props.updateCuentaResponse && 
                    <Alert style={{ textAlign: "center" }} severity={props.updateCuentaResponse.data? "success": "error"}> {props.updateCuentaResponse.message}</Alert>
                }
            </Stack>
        </Box>
        
        <CuentaBancariaDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onGuardar={handleGuardar}
            cuentaBancaria={cuentaSeleccionado}
        />
        <Dialog
            open={openConfirmDelete}
            onClose={handleCancelarEliminacion}
        >
            <DialogTitle>Confirmar eliminación</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    ¿Estás seguro que querés eliminar la cuenta bancaria {cuentaAEliminar?.nroCuenta}?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button 
                    type="submit" 
                    style={{background: colores.grisOscuro, color: 'white'}} className="btn" onClick={handleCancelarEliminacion}>
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    style={{background: colores.rojo, color: 'white'}} className="btn" onClick={handleConfirmarEliminacion}>
                    Eliminar
                </button>
            </DialogActions>
        </Dialog>
        </>
    );
};

export default connect(
    (state: any) => ({
        successUpdate: state.configuracion.successUpdate,
        datosCuentaBancaria: state.configuracion.datosCuentaBancaria,
        updateCuentaResponse: state.configuracion.updateCuentaResponse,
        successDatosBancarios: state.configuracion.successDatosBancarios,
        deleteCuentaResponse: state.configuracion.deleteCuentaResponse,
    }),
    (dispatch) => ({
        getDatosCuentaBancaria: () => dispatch(getDatosCuentaBancaria()),
        updateDatosCuentaBancaria: (formData: any) =>
            dispatch(updateDatosCuentaBancaria(formData)),
        deleteDatosCuentaBancaria: (id: number) => dispatch(deleteDatosCuentaBancaria(id))
    })
)(CuentaBancaria);